import type { CSSProperties } from '@mui/styles';

import AgTypography from '../../stories/Styles/AgTypography';

import { useAppSelector } from '../../redux/hooks';
import { selectVersion } from '../../redux/slices/global';
import { appEnv } from '../../api/environments';
import packageInfo from '../../../package.json';
import * as S from './styled';

type AgVersion = { fixed?: boolean, dataTestId?: string };

const TextStyle: CSSProperties = { 
  color: '#374722',
  fontSize: 10,
  fontWeight: 600,
  lineHeight: '20px', 
  textTransform: 'capitalize',
};

const AgVersion = ({ fixed, dataTestId }: AgVersion) => {
  const { environmentName = '', assemblyVersion = '0.0.0' } = useAppSelector(selectVersion) || {};

  return (
    <S.Container fixed={fixed} data-testid={dataTestId || 'version-root'} >
      <AgTypography component='p' style={TextStyle} data-testid='version-ui' >UI: {appEnv} {packageInfo.version}</AgTypography>
      <AgTypography component='p' style={TextStyle} data-testid='version-api'>API: {environmentName} {assemblyVersion}</AgTypography>
    </S.Container>
  );
};

export default AgVersion;